
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-pump",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 29.025v-24.6c-.1-1.4-1.2-2.55-2.6-2.65h-4.8c-2.55 0-4.75 1.65-5.55 4.1H8.5c-.45 0-.8.25-.95.65l-3.3 9.75c0 .05-.05.15-.05.2-.1.4-.15.8-.15 1.2 0 2.4 1.95 4.4 4.35 4.4.85 0 1.7-.25 2.45-.7v6.85h-10c-.5.1-.85.5-.85 1s.35.9.85 1H23.1c.25 0 .5-.1.7-.3s.25-.45.25-.7c0-.1 0-.15-.05-.2zm-7.4-25.25h4.8c.3.1.5.35.6.65v9.45h-9.15v-6.5c.1-2.05 1.75-3.6 3.75-3.6zm-8.2 16.3c-.75 0-1.45-.35-1.9-1-.45-.6-.55-1.4-.3-2.1 0-.05.05-.1.05-.2l1.75-5.2h.65c.3 0 .55-.2.65-.5l1.15-3.2h.35v9.95c-.1 1.3-1.15 2.25-2.4 2.25zm22.75 8.1c.5.1.85.5.85 1s-.35.9-.85 1H27c-.5-.1-.85-.5-.85-1s.35-.9.85-1h4.15z"}})])
          )
        }
      }
    